import { get, postData, getData, patchData } from "../base.ehq.model";
import { deserialize } from "../base.serializer";
import { serialize } from "./survey.serializer";

export const getSurvey = async (
  token,
  baseUrl,
  projectId,
  surveyId,
  config
) => {
  const queryPath = `${baseUrl}/projects/${projectId}/survey_tools/${surveyId}`;
  try {
    const res = await get(token, queryPath, {}, config);
    const relationship = {
      projects: {
        valueForRelationship: (relationship) => {
          return {
            id: relationship.id
          };
        }
      }
    };
    return deserialize(res, relationship);
  } catch (err) {
    throw new Error(err);
  }
};

export const getSurveyPage = async (
  token,
  baseUrl,
  projectId,
  surveyId,
  config
) => {
  const queryPath = `${baseUrl}/projects/${projectId}/survey_tools/${surveyId}/pages`;
  try {
    const res = await get(token, queryPath, {}, config);
    return deserialize(res);
  } catch (err) {
    throw new Error(err);
  }
};

export const createSurvey = async (
  token,
  baseUrl,
  projectId,
  surveyId,
  body = {},
  params = {}
) => {
  const queryPath = `${baseUrl}/projects/${projectId}/survey_tools/${surveyId}/survey_responses`;
  const serializedBody = serialize(body);
  return postData(token, queryPath, params, serializedBody).then((response) =>
    deserialize(response.data)
  );
};

export const updateSurvey = async (
  token,
  baseUrl,
  projectId,
  surveyId,
  responseId,
  body = {},
  params = {}
) => {
  const queryPath = `${baseUrl}/projects/${projectId}/survey_tools/${surveyId}/survey_responses/${responseId}`;
  const serializedBody = serialize(body);
  return patchData(token, queryPath, params, serializedBody).then((response) =>
    deserialize(response.data)
  );
};

export const getSurveyResponses = (
  token,
  baseUrl,
  projectId,
  surveyId,
  userId,
  config
) => {
  const queryPath = `${baseUrl}/projects/${projectId}/survey_tools/${surveyId}/survey_responses/${userId}`;

  return getData(token, queryPath, {}, config).then((response) =>
    deserialize(response.data)
  );
};

export const getQuestionResult = (
  token,
  baseUrl,
  projectId,
  surveyId,
  pageId,
  questionId
) => {
  const queryPath = `${baseUrl}/projects/${projectId}/survey_tools/${surveyId}/pages/${pageId}/questions/${questionId}/results`;

  return getData(token, queryPath).then((response) =>
    deserialize(response.data)
  );
};
